// extracted by mini-css-extract-plugin
export var text = "_40-0";